export function readScratchCollection() {
  try {
    const raw = localStorage.getItem("scratch");
    if (!raw) {
      return undefined;
    }
    const parsed = JSON.parse(raw);
    if (!parsed?.forms) {
      return undefined;
    }
    return { ...parsed, scratch: true };
  } catch {
    return undefined;
  }
}

export function clearScratchCollection() {
  localStorage.removeItem("scratch");
}
